import React from 'react'
import "../style/Vision.css";

const Vision = () => {
    return (
        <>
            <div className='vision'>
                <h1>
                    VISION
                </h1>
                <div className='vision_para'>
                    <p>To be the global benchmark in packaging innovation—
                        transforming industries through exceptional, sustainable, and
                        personalized packaging solutions that make a lasting impact on the
                        world.
                    </p>
                    <div className='vision_img'>
                        <div className='img1'></div>
                        <div className='img2'></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Vision